export enum ApiCredentialProvider {
  KeyVault = 'keyvault'
}
